module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer082"
    }
  }, [_c('p', {
    staticClass: "content-a",
    attrs: {
      "id": "calibre_toc_6"
    }
  }, [_c('span', {
    staticClass: "charoverride11"
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph1"
  }, [_c('span', {
    staticClass: "charoverride11"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_009#_idTextAnchor064",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Foreword")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_011#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Introduction")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_013#_idTextAnchor069",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Curiosities")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_014#_idTextAnchor071",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("A Question of Gladness")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_016#_idTextAnchor073",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Written in Stone")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_020#_idTextAnchor075",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Cleared for Take-Off")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_022#_idTextAnchor077",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Domesticities")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_023#_idTextAnchor079",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Taking the Plunge")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_025#_idTextAnchor081",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Charmed, I’m Sure")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_028#_idTextAnchor083",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("The Nature of Niches")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_030#_idTextAnchor085",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("A Sign of Gratitude")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_033#_idTextAnchor087",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Geographies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_034#_idTextAnchor089",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("A Visit to Liberty")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_036#_idTextAnchor092",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Idiosyncracies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  })]), _c('span', {
    staticClass: "charoverride12"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_038#_idTextAnchor094",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Bless This Mess")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_039#_idTextAnchor096",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Having a Cigarette")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_041#_idTextAnchor098",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Demittere Diem")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_043#_idTextAnchor100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("A Personal Holiday Tradition")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_046#_idTextAnchor102",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Intimate Furniture")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_048#_idTextAnchor104",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Tending Pleasures")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_049#_idTextAnchor107",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Botanies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_051#_idTextAnchor109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Root Truth")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_053#_idTextAnchor111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Ridiculously Tiny Trees")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_055#_idTextAnchor113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Quizzical Squash")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_057#_idTextAnchor115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Muguets and Tissues")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_059#_idTextAnchor117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Sprung")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_061#_idTextAnchor119",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Startle Display")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_063#_idTextAnchor121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Coincidence of Rarities")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_065#_idTextAnchor123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Geographies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_066#_idTextAnchor125",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("The Smudge Between the Stars")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_067#_idTextAnchor127",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Creativities")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_068#_idTextAnchor129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("A Pocket-Sized Mystery")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_070#_idTextAnchor131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Questionable Qualifications")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_072#_idTextAnchor133",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("A Cherished Mistake")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_074#_idTextAnchor135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("No Masterpiece")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_076#_idTextAnchor138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("The Birthing Tent")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_078#_idTextAnchor140",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Why Write")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_079#_idTextAnchor142",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Geographies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_080#_idTextAnchor144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Paris: A Literary Truffle")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_082#_idTextAnchor146",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Technologies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_083#_idTextAnchor148",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Tapdance")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_086#_idTextAnchor150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Derailed and Rerailed")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_088#_idTextAnchor152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Angle Matters")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_089#_idTextAnchor154",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Words on a Page")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_091#_idTextAnchor156",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Phorgotten Phone")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_094#_idTextAnchor159",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Fragilities")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_095#_idTextAnchor161",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("The Cookie Crumbles")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_099#_idTextAnchor164",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Geographies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_100#_idTextAnchor166",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("City of Strings")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_102#_idTextAnchor168",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Walking South")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_105#_idTextAnchor170",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Tell of Israel")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_107#_idTextAnchor173",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Sympathies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_109#_idTextAnchor175",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Broken Just So")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_111#_idTextAnchor177",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("A Phrase to Melt Anxiety")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_114#_idTextAnchor179",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("Soulgrowing")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_117#_idTextAnchor181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Geographies")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_118#_idTextAnchor183",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride13"
  }, [_vm._v("The Limitless Within")])]), _c('span', {
    staticClass: "charoverride13"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_119#_idTextAnchor185",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Glad to Be Human")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_122#_idTextAnchor189",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Afterword")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_125#_idTextAnchor191",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Acknowledgements")])]), _c('span', {
    staticClass: "charoverride12"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_127#_idTextAnchor193",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("Publication Credits")])]), _c('span', {
    staticClass: "charoverride12"
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/GladtoBeHuman_split_129#_idTextAnchor196",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride12"
  }, [_vm._v("About the Author")])]), _c('span', {
    staticClass: "charoverride12"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_18"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4581aaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/GladtoBeHuman_split_008.vue
// module id = 84
// module chunks = 0